import React from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { GridCell } from "@progress/kendo-react-grid";
import { formatNumber } from '@telerik/kendo-intl';
export default class NumericComponentForScenario extends GridCell {

    handleChange = (e) => {
        const value = this.props.dataItem[this.props.field];
        if (value) {
            let split = value.split('_')
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value + ' - ' + split[1],
            });
        } else {
            this.props.onChange({
                dataItem: this.props.dataItem,
                field: this.props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value + ' - ' + (0),
            });
        }
    }
    handleEditCell = () => {
        if (this.props.dataItem.inEdit !== true && this.props.dataItem[this.props.field]) {
            this.props.onEditCell(this.props.dataItem, this.props.field, this.props.stateData);
        }
    }
    render() {
        const value = this.props.dataItem[this.props.field];
        let originalValue;
        let approvalValue;
        let newApprovalValue;
        let split = [];
        if (value) {
            if (typeof value === 'string') {
                split = value.split('_');
                originalValue = parseInt(split[0])
                approvalValue = split[1].split('$')[0];
                newApprovalValue = split[1].split('$')[1];
            } else {
                originalValue = value
            }
        } else {
            split = [0, 0]
        }

        if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
            return (
                <td>
                    <NumericTextBox
                        value={originalValue}
                        onChange={this.handleChange}
                    />
                </td>
            );
        }
        if ((this.props.dataItem.inEdit !== this.props.field) || this.props.dataItem.inEdit === true) {
            return (
                <td onClick={this.handleEditCell}>
                    {
                        originalValue||parseFloat(originalValue)===0?(
                   <span>{formatNumber(parseFloat(originalValue), "##,#") + '  '}
                     
                    <span className='yellowCell' title="Approved Value">&nbsp;
                        ({formatNumber(parseFloat(approvalValue), "##,#")})
                     </span>
                   <span className='lightGreen' title="New Approved Value">&nbsp;
                        {'(' + formatNumber(parseFloat(newApprovalValue), "##,#") + ')'}
                     </span>
                    </span>
                        ):("")
                    }
                    
                </td>
            );
        }
    }
}
